"use client";
import { FC } from "react";
import { CHAR_LIMITS, textEllipsis } from "./clpCardConstant";
import { PriceDisplayProps } from "./types";

export const PriceDisplay: FC<PriceDisplayProps> = ({ ltp, isPositive }) => (
  <div className="flex items-center gap-[4px]">
    <span
      className={`stock-price-value  text-[14px] sm:text-[16px] ${
        isPositive ? "green-100 text-[#067161]" : "red-100 text-red-600"
      }`}
    >
      {textEllipsis(
        ltp?.toString() || "",
        CHAR_LIMITS.PRICE_VALUE,
        "stock-price-value",
      )}
    </span>
    {isPositive ? (
      <i className="icomoon text-[12px] text-[#067161] before:content-['\e980']" />
    ) : (
      <i className="icomoon text-[12px] text-red-700 before:content-['\e981']" />
    )}
  </div>
);

